module.exports = __webpack_public_path__ + "static/media/sx.ca10c62e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/sx.png
// module id = 1989
// module chunks = 0